import React, { useState, useEffect } from "react";
import { Star, ChevronLeft, ChevronRight, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const PHOTOS = ["/reviews/r1.jpg", "/reviews/r2.jpg", "/reviews/r3.jpg", "/reviews/r4.jpg", "/reviews/r5.jpg", "/reviews/r6.jpg"];

const REVIEWS = [
  { author: "Iñigo", title: "Tour Torrevieja", text: "Descubrimos un montón de cosas que no sabíamos y ahora miramos las calles de Torrevieja con otros ojos. Héctor, genial: nos contó historias y curiosidades con muchísimo salero y el tour se nos pasó volando." },
  { author: "Iuliia I", title: "¡Genial!", text: "Héctor es torrevejense, conoce muy bien la historia de la ciudad y no solo cuenta datos históricos, sino también historias locales que no se encuentran en Internet. ¡Totalmente recomendable!" },
  { author: "Alba U", title: "¡Maravilla de tour!", text: "Lo hicimos en familia y descubrimos cosas súper interesantes. Héctor te hace disfrutar desde la cultura y la historia, y también te dice dónde comerte un buen arroz y pulpo." },
  { author: "Coastal21304242369", title: "Una experiencia imprescindible", text: "Héctor era culto, cautivador y un apasionado de la historia y la cultura de la ciudad. El tiempo pasó volando. ¡Muy recomendable para cualquiera que la visite!" },
];

const Stars = () => (
  <div className="flex gap-0.5">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={13} className="text-amber-400 fill-amber-400" />)}
  </div>
);

const Lightbox = ({ index, onChange }) => {
  const open = index !== null;
  const go = (d) => onChange((index + d + PHOTOS.length) % PHOTOS.length);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });
  const [touchX, setTouchX] = useState(null);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onChange(null)}>
      <DialogContent className="max-w-4xl p-0 bg-black border-0 overflow-hidden [&>button]:hidden" data-testid="photo-lightbox">
        <DialogTitle className="sr-only">Free Tour Torrevieja</DialogTitle>
        {open && (
          <div className="relative" onTouchStart={(e) => setTouchX(e.touches[0].clientX)}
            onTouchEnd={(e) => { if (touchX === null) return; const dx = e.changedTouches[0].clientX - touchX; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); setTouchX(null); }}>
            <img src={PHOTOS[index]} alt={`Free Tour Torrevieja ${index + 1}`} className="w-full max-h-[80vh] object-contain" data-testid="lightbox-image" />
            <button onClick={() => go(-1)} data-testid="lightbox-prev" aria-label="Anterior"
              className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-md flex items-center justify-center text-white transition-colors"><ChevronLeft /></button>
            <button onClick={() => go(1)} data-testid="lightbox-next" aria-label="Siguiente"
              className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-md flex items-center justify-center text-white transition-colors"><ChevronRight /></button>
            <button onClick={() => onChange(null)} data-testid="lightbox-close" aria-label="Cerrar"
              className="absolute right-2 top-2 w-9 h-9 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center text-white transition-colors"><X size={18} /></button>
            <span className="absolute bottom-3 left-1/2 -translate-x-1/2 text-white/90 text-xs bg-black/40 px-3 py-1 rounded-full" data-testid="lightbox-counter">{index + 1} / {PHOTOS.length}</span>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export const ReviewsShowcase = ({ title, sourceLabel }) => {
  const [photo, setPhoto] = useState(null);
  return (
  <section className="mt-10" data-testid="reviews-showcase">
    <div className="flex items-end justify-between mb-4">
      <h3 className="font-heading text-2xl text-coastal-text">{title}</h3>
      <span className="flex items-center gap-1 text-xs text-coastal-muted"><Stars /> 5,0</span>
    </div>
    <div className="grid grid-cols-3 gap-2 mb-5" data-testid="reviews-photos">
      {PHOTOS.map((src, i) => (
        <button key={src} type="button" onClick={() => setPhoto(i)} data-testid={`review-photo-${i}`} className="overflow-hidden rounded-lg cursor-zoom-in">
          <img src={src} alt={`Free Tour Torrevieja ${i + 1}`} loading="lazy"
            className="w-full aspect-square object-cover hover:scale-105 transition-transform duration-300" />
        </button>
      ))}
    </div>
    <div className="space-y-3">
      {REVIEWS.map((r, i) => (
        <article key={r.author} data-testid={`review-card-${i}`}
          className="p-4 rounded-xl bg-white border border-coastal-secondary shadow-[0_4px_16px_rgba(0,0,0,0.04)]">
          <div className="flex items-center justify-between mb-1.5">
            <p className="font-semibold text-coastal-text text-sm">{r.title}</p>
            <Stars />
          </div>
          <p className="text-coastal-muted text-sm leading-relaxed">"{r.text}"</p>
          <p className="text-xs text-coastal-muted/80 mt-2">— {r.author} · {sourceLabel}</p>
        </article>
      ))}
    </div>
    <Lightbox index={photo} onChange={setPhoto} />
  </section>
  );
};

export default ReviewsShowcase;
